// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageLike-modulechatroomMessageLike__unlSp";
export { _1 as "chatroomMessageLike" }
